export enum Payer {
  PET_OWNER = "PET_OWNER",
  INSURANCE_COMPANY = "INSURANCE_COMPANY"
}
